import NavBar from "../common/NavBar";
import NavBarFooter from "../common/NavBarFooter";
import QuizAPI from "../components/quiz_api";

const MusicQuiz = () => {
    return (
        <div className="outline">
            <NavBar />
            <h1>Music Quiz</h1>
            <p>Did you know that 87.64% of the world listen to music? <br />
            Show us what you got!</p>
            {/* <QuizzMaster endpoint="music" /> */}
            <QuizAPI category="12" />
            <NavBarFooter />
        </div>
    )
}

export default MusicQuiz;